import { Capacitor } from "@capacitor/core";
import { CapacitorPlatformAdapter } from "./CapacitorPlatformAdapter";
import type { PlatformAdapter } from "./types";
import { WebPlatformAdapter } from "./WebPlatformAdapter";

export type { PlatformAdapter, PlatformCapability, PlatformType, PushPayload, ShareContent, ShareImage, ShareImageOutcome, ShareOutcome } from "./types";
export { UNAVAILABLE_MESSAGES } from "./types";

/**
 * True inside the Capacitor shell. The shell's web view lifts the browser's gesture
 * requirement for audio (Capacitor sets mediaTypesRequiringUserActionForPlayback to []), so
 * the app's own audio gates can let sound start at boot there (sound-and-music contract §5).
 */
export function isNativePlatform(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

export function createPlatformAdapter(): PlatformAdapter {
  if (Capacitor.isNativePlatform()) {
    return new CapacitorPlatformAdapter();
  }
  return new WebPlatformAdapter();
}
